import apiClient from '../../../services/api-client'
import type {
  Announcement,
  CreateAnnouncementRequest,
  UpdateAnnouncementRequest,
  ListAnnouncementsResponse
} from '../types/announcement.types'

export interface ListAnnouncementsOptions {
  includeInactive?: boolean
}

export async function listAnnouncements(options?: ListAnnouncementsOptions): Promise<Announcement[]> {
  const params = options?.includeInactive ? {} : { isActive: true }
  const response = await apiClient.get<ListAnnouncementsResponse>('/announcement', { params })
  return response.data.data
}

export async function getAnnouncement(id: string): Promise<Announcement> {
  const response = await apiClient.get<Announcement>(`/announcement/${id}`)
  return response.data
}

export async function createAnnouncement(request: CreateAnnouncementRequest): Promise<{ id: string }> {
  const response = await apiClient.post<{ id: string }>('/announcement', request)
  return response.data
}

export async function updateAnnouncement(id: string, request: UpdateAnnouncementRequest): Promise<void> {
  await apiClient.put(`/announcement/${id}`, { id, ...request })
}

export async function deleteAnnouncement(id: string): Promise<void> {
  await apiClient.delete(`/announcement/${id}`)
}
